import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {AcceptanceRule} from "../../model/customer/acceptance-rule";

@Injectable({
  providedIn: 'root'
})
export class CustomerAcceptanceRuleService extends CommonCrudService<AcceptanceRule> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_ACCEPTANCE_RULE_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_ACCEPTANCE_RULE,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_ACCEPTANCE_RULE);
  }

}
